
import React from 'react';
import DialogActions from '@material-ui/core/DialogActions/';
import DialogContent from '@material-ui/core/DialogContent/';
import DialogContentText from '@material-ui/core/DialogContentText/';
import DialogTitle from '@material-ui/core/DialogTitle/';
import { Button, StyledDialog } from './components/Dialog/style';

export default function AddServices({ open, closeDialog, confirm, title, hideTitle, message }) {
  return (
    <div>
      <StyledDialog
        open={open}
        onClose={closeDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {!hideTitle && <DialogTitle id="alert-dialog-title">{title && title !== '' ? title : "Adicionar serviços"}</DialogTitle>}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message && message !== '' ? message : 'A lista de serviços será adicionada em breve.'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>
            Cancelar
          </Button>
          <Button onClick={confirm} color="primary" autoFocus disabled>
            Confirmar
          </Button>
        </DialogActions>
      </StyledDialog>
    </div>
  );
}
